// 쿠키
import Cookies from "js-cookie";

// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";

// ✅ 뷰 import (프로젝트 경로에 맞게 조정)
import FAQView from "@/views/public/FAQView.vue";
import ASPublicLookup from "@/views/public/ASPublicLookup.vue";
import NotFound from "@/views/public/404NotFound.vue";
import LoginView from "@/views/admin/LoginView.vue";
import AdminLayout from "@/views/admin/AdminLayout.vue";
import MembersView from "@/views/admin/MembersView.vue";
import ManageView from "@/views/admin/ASManage.vue";
import TimeView from "@/views/admin/TimeView.vue";
import TimeView2 from "@/views/admin/TimeView2.vue";
// import ASPublicView from "@/views/public/ASPublicView.vue";
// import ASPublicExpired from "@/views/public/ASPublicExpired.vue";
// import GroupManageView from "@/views/admin/GroupManageView.vue";
// import DeviceListView from "@/views/admin/DeviceListView.vue";
// import GroupDevicesView from "@/views/admin/GroupDevicesView.vue";
// import ASManageView from "@/views/admin/ASManageView.vue";
// import ASAddView from "@/views/admin/ASAddView.vue";
// import DeviceAppMainView from "@/views/app/DeviceAppMainView.vue";
// import ASRequestView from "@/views/app/ASRequestView.vue";

/**
 * ✅ 인증 상태 확인 함수
 * - 실제로는 Pinia store / 쿠키 / localStorage 토큰 등을 확인하도록 바꾸면 됨
 */
function isAuthenticated() {
  const token = Cookies.get("Authorization");
  return Boolean(token);
}

const routes = [
  // ===== Public (No login) =====
  // FAQ
  {
    path: "/",
    name: "Lookup",
    component: ASPublicLookup,
    meta: { public: true }
  },
  // A/S 조회
  {
    path: "/faq",
    name: "FAQ",
    component: FAQView,
    meta: { public: true }
  },
  // {
  //   path: "/",
  //   redirect: "/login"
  // },
  // {
  //   // 만료 안내
  //   path: "/as/expired",
  //   name: "ASPublicExpired",
  //   component: ASPublicExpired,
  //   meta: { public: true }
  // },
  // {
  //   // 1회용 URL 조회 (로그인 X)
  //   path: "/as/:token",
  //   name: "ASPublicView",
  //   component: ASPublicView,
  //   meta: { public: true }
  // },

  // ===== 테스트용 사용자 앱 =====

  // {
  //   path: "/app",
  //   name: "DeviceAppMain",
  //   component: DeviceAppMainView,
  //   meta: { public: true }
  // },
  // {
  //   path: "/app/as",
  //   name: "ASRequest",
  //   component: ASRequestView,
  //   meta: { public: true }
  // },
  // {
  //   path: "/app/as/status",
  //   name: "ASStatus",
  //   component: () => import("@/views/app/ASStatusView.vue"),
  //   meta: { public: true }
  // },

  // ===== Admin (Login required) =====
  // 로그인
  {
    path: "/admin",
    name: "Login",
    component: LoginView,
    meta: { public: true }
  },

  // 관리자 페이지
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: "user",
        component: MembersView
      },
      {
        path: "manage",
        component: ManageView
      },
      {
        path: "time",
        component: TimeView
      },
      {
        path: "time2",
        component: TimeView2
      }
      // {
      //   path: "",
      //   redirect: "/admin/groups"
      // },
      // {
      //   path: "groups",
      //   name: "GroupManage",
      //   component: GroupManageView
      // },
      // {
      //   // x
      //   // 전체보기 디바이스 목록(선택적으로 사용)
      //   path: "devices",
      //   name: "DeviceList",
      //   component: DeviceListView
      // },
      // {
      //   // x
      //   // 그룹별 디바이스 관리
      //   path: "groups/:groupId",
      //   name: "GroupDevices",
      //   component: GroupDevicesView,
      //   props: true
      // },
      // {
      //   // 전체 A/S 현황
      //   path: "as",
      //   name: "ASManage",
      //   component: ASManageView
      // },
      // {
      //   // A/S 접수
      //   path: "asAdd",
      //   name: "ASAdd",
      //   component: ASAddView
      // },
    ]
  },
  // {
  //   path: "/admin/devices/:uuid",
  //   name: "admin-device-detail",
  //   component: () => import("@/views/admin/DeviceDetailView.vue"),
  //   meta: { requiresAuth: true }
  // },
  // 404
  {
    path: "/:pathMatch(.*)*",
    name: "404NotFound",
    component: NotFound
  }
];

import { getAdminScope } from "@/utils/adminScope";

const router = createRouter({
  history: createWebHistory(),
  routes
});

/**
 * ✅ beforeEach 가드 정책
 * 1) requiresAuth인데 미인증 → /login?redirect=원래경로
 * 2) /login인데 이미 인증됨 → /admin/groups
 */
router.beforeEach((to, from, next) => {
  if (to.path === "/admin/time2" && getAdminScope().restricted) {
    next("/admin/time");
    return;
  }
  const authed = isAuthenticated();

  if (to.meta.requiresAuth && !authed) {
    next("/admin"); // 로그인으로
  } else if (to.path === "/admin" && authed) {
    next("/admin/user"); // 로그인 되어있으면 관리자 홈으로
  } else {
    next();
  }
});

export default router;
